import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';

import { messages as i18n } from '@teem/constants/messages';
import { HIDE_PAYMENT_DATE } from '@teem/constants/defaults';

@Component({
  selector: 'tamara-tab',
  templateUrl: './tamara-tab.component.html',
  styleUrls: ['./tamara-tab.component.scss']
})
export class TamaraTabComponent implements OnInit {
  @Output() public updateUserDetails = new EventEmitter();
  @Output() public goToPlan = new EventEmitter();
  submitted: boolean = false;
  userDetails: any = null;
  labelStatus :string = 'default_show';
  dueDate:any = moment(HIDE_PAYMENT_DATE);
  nowDate:any = moment();

  merchantForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private userService: UserService,
    private sharedDataService: SharedDataService
  ) { }


  ngOnInit(): void {
    this.merchantForm = this.fb.group({
      tamara_access_token: [this.userDetails ? this.userDetails.tamara_access_token : '', Validators.required],
    });
  }

  @Input('userDetails')
  set setUserDetails(val: any) {
    // console.log(val , this.merchantForm);
    if(val) {
      this.userDetails = val;

      if(this.merchantForm) {
        this.merchantForm.get('tamara_access_token').setValue(val.tamara_access_token);
      }

    } else {
      if(this.merchantForm) {
        this.merchantForm.get('tamara_access_token').setValue('');
      }
    }

    if (this.userDetails?.subscription.subscription_status == 'free') {
      this.labelStatus = 'free_user';
    } else {
      this.labelStatus = 'paid_user';
    }
    
  }

  get f() {
    return this.merchantForm.controls;
  }

  onSubmit(form: FormGroup) {
    this.submitted = true;
    if (form.valid) {
      this.loaderService.startLoading();
      this.userService.addTamaraAccessToken('store', form.value).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();

          // Update parent user
          this.userDetails.tamara_access_token = res.user.tamara_access_token;
          this.userDetails.accept_tamara = res.user.accept_tamara;
          this.updateUserDetails.emit(this.userDetails);

          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            userInfo.tamara_access_token = res.user.tamara_access_token;
            userInfo.accept_tamara = res.user.accept_tamara;
            this.sharedDataService.setItem('userInfo', userInfo);
          }

          Swal.fire(i18n.done, i18n.setting.tamara_added, 'success');
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.merchantForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      )

    }
  }

  deleteMerchant() {
    this.submitted = false;
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.setting.remove_tamara_confirm,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then( (result:any) => {
      if (result.value) {
        this.loaderService.startLoading();
        this.userService.removeTamaraAccessToken('delete').subscribe((data: any) => {
          this.loaderService.stopLoading();

          this.merchantForm.get('tamara_access_token').setValue('');

          // Update parent user
          this.userDetails.tamara_access_token = null;
          this.userDetails.accept_tamara = 0;
          this.updateUserDetails.emit(this.userDetails);

          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            userInfo.tamara_access_token = null;
            userInfo.accept_tamara = 0;
            this.sharedDataService.setItem('userInfo', userInfo);
          }

          setTimeout(function () {
            Swal.fire(i18n.done, i18n.setting.remove_tamara_success, 'success');
          }, 0);
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      } else {
        return false;
      }
    });

  }


}
